module.exports = __webpack_public_path__ + "257e9ebf526426f3a4cec59d08ba69c1.mp4";